<template>
  <section
    :class="`rounded-md bg-contain md:bg-cover md:bg-center shadow-md md:shadow-sm ${color()}`"
    :style="backgroundImage(background())"
  >
    <div class="grid grid-cols-12 gap-5 p-5">
      <div class="col-span-12 sm:col-span-3 lg:col-span-3 xl:col-span-3">
        <img :src="avatar()" alt="homero-state" class="w-full h-56" />
      </div>
      <div
        class="col-span-12 sm:col-span-9 lg:col-span-9 xl:col-span-9 flex items-center p-2"
      >
        <div class="flex flex-col gap-3 text-center md:text-start w-full">
          <div class="w-full">
            <div class="flex flex-row w-full justify-between">
              <h3>{{ title() }}</h3>
              <div>
                <MessageVoice :msg="message()" />
              </div>
            </div>
            <p class="mt-2">{{ message() }}</p>
          </div>
          <div v-if="data?.percentage >= 60" class="w-full flex flex-col gap-3">
            <Button
              class="btn-primary h-10"
              :loading="loading"
              @click="onProceed('proceed')"
            >
              {{ $t("quiz.result.proceed") }}
            </Button>
            <Button
              v-if="isAdaptative"
              class="btn-outline-bg-white h-10"
              :loading="loading"
              @click="onProceed('more-materials')"
            >
              {{ $t("quiz.result.more") }}
            </Button>
          </div>
          <div v-else class="w-full flex flex-col gap-3">
            <p>      
              {{
                $t("labels.generic", {
                  pt: "Vamos começar?",
                  en: "Let's start?",
                })
              }}
            </p>
            <Button
              class="btn-primary h-10"
              :loading="loading"
              @click="onProceed('quiz-materials')"
            >
              {{ $t("quiz.result.moreMaterialsQuiz") }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <h4 class="mt-8">
    {{
      $t("labels.generic", { pt: "Correção do Quiz", en: "Quiz correction" })
    }}
  </h4>
  <div
    class="mt-2 p-4 bg-white border-b-2 border-h-primary-500 space-y-4 rounded-md shadow-md"
  >
    <div>
      <p>
        <span>{{ $t("quiz.result.currentPercentage").concat(": ") }}: </span>
        <strong>{{ data?.percentage }}%</strong>
      </p>
    </div>
    <div
      class="flex flex-wrap justify-start items-center gap-5"
    >
      <p>
        <span>{{ $t("quiz.result.minPercentage").concat(": ") }}</span>
        <strong>60%</strong>
      </p>
      <p>
        <span>{{ $t("quiz.result.duration").concat(": ") }}</span>
        <strong>{{ generics.getDurationTime(data?.elapsedTime) }}</strong>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { GenericsUtils } from "@/utils/generics.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent } from "vue";

export default defineComponent({
  name: "resultHeader",
  emits: ["onProceed"],
  computed: {
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  props: {
    isAdaptative: {
      type: Boolean,
      default: true,
    },
    data: [Object],
    learningName: [String],
  },
  data() {
    return {
      loading: false as boolean,
    };
  },
  methods: {
    backgroundImage(image: any): any {
      return {
        "background-image": `url(${image})`,
        "background-repeat": "no-repeat",
      };
    },
    title(): string {
      var value = "";
      if (this.data?.percentage >= 60) {
        value = this.$t("quiz.result.good");
      } else {
        value = this.$t("quiz.result.fail");
      }
      return value;
    },
    message(): string {
      var value = "";
      if (this.data?.percentage >= 60) {
        value = `${this.user.firstName}, ${this.$t(
          "quiz.result.messageGood"
        )} ${this.learningName}. ${this.$t(
          "quiz.result.messageGoodMoreMaterials"
        )}`;
      } else {
        value = `${this.user.firstName}, ${this.$t("quiz.result.messageFail")}`;
      }
      return value;
    },
    avatar(): string {
      var value = "";
      if (this.data?.percentage >= 60) {
        value = require("@/assets/images/quiz_approved.svg");
      } else {
        value = require("@/assets/images/quiz_repproved.svg");
      }
      return value;
    },
    background(): string {
      var value = "";
      if (this.data?.percentage >= 60) {
        value = require("@/assets/images/quiz_bg_approved.png");
      } else {
        value = require("@/assets/images/quiz_bg_repproved.png");
      }
      return value;
    },
    color(): string {
      var value = "";
      if (this.data?.percentage >= 60) {
        value = "bg-h-info-100";
      } else {
        value = "bg-h-warning-100";
      }
      return value;
    },
    onProceed(type: string): void {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$emit("onProceed", type);
      }, 500);
    },
  },
});
</script>
